<template>
    <div class="select-unit-type-modal">
        <ItemsSearchAndSelect
            v-model="selected"
            :list="list"
            radioGroupName="unitTypesList"
            inputName="unit_type"
            itemCreateModalName="UnitTypeCreateModal"
            itemCreateModalTitle="§eq_type.create_new_type_modal_title"
            searchPlaceholder="§ui.search_equipment_type"
            class="mb-6"
        />
        <div class="flex justify-start gap-2">
            <CoreButton
                :disabled="selected === null"
                label="§ui_button.select"
                icon="pi-arrow-right"
                @click="handleSet"
            />
            <CoreButton
                label="§ui_button.cancel"
                variant="tertiary"
                @click="closeModal"
                icon="pi-times"
            />
        </div>
    </div>
</template>

<script>
import { useCafStore } from '@/stores/caf'
import { useModalStore } from '@/stores/modal'
import CoreButton from '@/components/core/CoreButton.vue'
import ItemsSearchAndSelect from './ItemsSearchAndSelect.vue'
import { PRODUCT_TYPE_NAMES } from '@/data/constants'

export default {
    name: 'SelectUnitTypeModal',

    components: {
        ItemsSearchAndSelect,
        CoreButton,
    },

    data() {
        return {
            cafStore: useCafStore(),
            modalStore: useModalStore(),

            list: null,
            selected: null,
        }
    },

    mounted() {
        this.getList()
    },

    methods: {
        async getList() {
            this.list = await this.cafStore.getItemList('unit_type.index')
        },

        handleSet() {
            this.cafStore.sharedInputs.unit_type = this.selected

            const type = this.list.filter((item) => item.id === this.selected)[0]

            this.cafStore.sharedInputs.unit_type_name = type.name
            this.cafStore.sharedInputs.currency_code = type.currency_code
            this.cafStore[PRODUCT_TYPE_NAMES.PPU].unit_type_max_usage = type.max_usage
            this.cafStore[PRODUCT_TYPE_NAMES.PPU].unit_type_planned_usage = type.planned_usage

            const billingUnitKeys = Object.keys(type.billing_units)

            if (billingUnitKeys.length > 0) {
                const billingUnits = Object.keys(type.billing_units).map((label) => ({
                    label,
                    value: type.billing_units[label],
                }))
                this.cafStore[PRODUCT_TYPE_NAMES.PPU].unit_type_billing_units = billingUnits
                this.cafStore[PRODUCT_TYPE_NAMES.PPU].billing_unit = billingUnits.at(0).value
            }
            this.cafStore.sharedInputs.net_list_price = type.net_list_price

            if (!this.cafStore[PRODUCT_TYPE_NAMES.PPU].expected_utilization) {
                this.cafStore[PRODUCT_TYPE_NAMES.PPU].expected_utilization = type.planned_usage
            }

            this.modalStore.setClose()
        },

        closeModal() {
            this.modalStore.setClose()
        },
    },
}
</script>
